import { connect } from 'react-redux';
import { goToOrderDetails } from '../../../../../../store/orders/order-details/orders.details.actions';

import { AnchorAtStartCustomAlert } from './index';

const mapDispatchToProps = (dispatch, { salesOrderID }) => {
  return {
    onClick: () => {
      dispatch(goToOrderDetails({ salesOrderId: salesOrderID }));
    },
  };
};

export const AnchorAtStartCustomAlertContainer = connect(null, mapDispatchToProps)(AnchorAtStartCustomAlert);
